import withKeyboardFittingElement from 'HOCs/withKeyboardFittingElement';
import ButtonCommon from 'components/common/ButtonCommon';
import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  REGISTER_STREET_TYPES,
} from 'constants';
import withFormPIIProfileResidentialAddressInitial from 'features/pii/HOCs/withFormPIIProfileResidentialAddressInitial';
import {
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
} from 'features/pii/const';
import { checkFormInputValidation } from 'features/pii/func';
import usePII from 'features/pii/hooks/usePII';
import usePIIStore from 'features/pii/hooks/usePIIStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import {
  displayFlexRowCenterSpaceBetweenMixin,
  textEllipsisFirstLineMixinObj,
} from 'styles';
import CustomAddressFinderDropdown from './components/CustomAddressFinderDropdown';
import CustomAddressPostcodeDropdown from './components/CustomAddressPostcodeDropdown';
import FormInputAddressFinderManualSwitch from './components/FormInputAddressFinderManualSwitch';
import FormInputValidation from './components/FormInputValidation';

const FormPIIProfileResidentialAddress = withKeyboardFittingElement(
  withFormPIIProfileResidentialAddressInitial(
    ({
      inputRef,
      currentStep,
      setCurrentStep,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    }) => {
      const { t } = useLang();
      const { isDesktop } = useDetectDevice();
      const {
        isLoading,
        personalDetails,
        setPIIProfileResidentialAddress,
        setLoading,
      } = usePIIStore();
      const { handleSubmitSignupPII } = usePII();

      const isEnterAddressManual = Boolean(
        information[PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]
      );

      const isNextButtonDisabled =
        isLoading ||
        !checkAllowSubmit({
          information,
          validation,
          skipProps: [
            PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
            ...(isEnterAddressManual
              ? [
                  !(
                    information[
                      PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME
                    ] &&
                    checkFormInputValidation(
                      information[
                        PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME
                      ],
                      PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD,
                      information,
                      validation
                    )?.[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME]
                  ) && PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
                ]
              : [
                  !(
                    information[
                      PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME
                    ] &&
                    checkFormInputValidation(
                      information[
                        PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME
                      ],
                      PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD,
                      information,
                      validation
                    )?.[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME]
                  ) && PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
                  !information[
                    PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME
                  ] && PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
                ]),
          ],
        });

      const handleBackStep = () => {
        setCurrentStep(currentStep - 1);
      };

      const handleNextStep = async () => {
        console.log(
          `⭐ FormPIIProfileResidentialAddress 👉 handleNextStep ➡️ information ↩`,
          information
        );
        if (isNextButtonDisabled) return;
        try {
          console.log(
            `⭐ FormPIIProfileResidentialAddress 👉 handleNextStep ➡️ information ↩`,
            information
          );
          setLoading(true);
          setPIIProfileResidentialAddress(information);
          handleSubmitSignupPII({
            personalDetailsInformation: personalDetails,
            residentialAddressInformation: information,
          });
        } catch (error) {
          console.error(
            `🔥 FormPIIProfileResidentialAddress ❌ handleNextStep ➡️ ERROR ↩`,
            error?.message
          );
        }
      };

      const renderFormEnterAddressManual = () => {
        if (!isEnterAddressManual) return null;
        return (
          <>
            <SizeBox height={isDesktop ? 40 : 16} />
            <FormEnterAddressManualStyled>
              <EnterAddressManualRow>
                <FormInputValidation
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  checkFormInputValidation={checkFormInputValidation}
                />
                <FormInputValidation
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  checkFormInputValidation={checkFormInputValidation}
                />
              </EnterAddressManualRow>
              <SizeBox height={16} />
              <EnterAddressManualRow>
                <FormInputValidation
                  ref={inputRef}
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  checkFormInputValidation={checkFormInputValidation}
                />
                <CustomSearchDropdown
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD}
                  data={REGISTER_STREET_TYPES}
                  keyFind="key"
                  keyTranslate="value"
                  noResultText="form_text_no_result"
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  styles={{
                    width: '100%',
                    marginBottom: 0,
                  }}
                  toggleTextStyles={textEllipsisFirstLineMixinObj}
                />
              </EnterAddressManualRow>
              <SizeBox height={16} />
              <EnterAddressManualRow>
                <CustomAddressPostcodeDropdown
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                />
              </EnterAddressManualRow>
              <SizeBox height={16} />
              <EnterAddressManualRow>
                <FormInputValidation
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  checkFormInputValidation={checkFormInputValidation}
                />
                <FormInputValidation
                  field={PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD}
                  information={information}
                  setInformation={setInformation}
                  validation={validation}
                  setValidation={setValidation}
                  checkFormInputValidation={checkFormInputValidation}
                />
              </EnterAddressManualRow>
            </FormEnterAddressManualStyled>
            <SizeBox height={isDesktop ? 40 : 0} />
          </>
        );
      };

      const renderCustomAddressFinderDropdown = () => {
        if (isEnterAddressManual) return null;
        return (
          <>
            <CustomAddressFinderDropdown
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
            />
            <SizeBox height={30} />
          </>
        );
      };

      const renderBottomFixed = () => {
        return (
          <BottomFixedStyled>
            <ButtonCommon
              value={t('button_back')}
              onClick={handleBackStep}
              styles={{
                margin: '0px',
                height: '50px',
                width: '50%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
            />
            <ButtonCommon
              value={t('button_confirm')}
              styles={{
                margin: '0px',
                height: '50px',
                width: '50%',
              }}
              color={
                isNextButtonDisabled
                  ? 'var(--ds-c-blue-disabled)'
                  : 'var(--c-primary)'
              }
              background={
                isNextButtonDisabled ? 'var(--ds-bg-4)' : 'var(--bg-primary)'
              }
              onClick={isNextButtonDisabled ? FUNC_DEFAULT : handleNextStep}
              isUseKeyDown
              isFill={true}
            />
          </BottomFixedStyled>
        );
      };

      return (
        <FormPIIProfileResidentialAddressStyled>
          {renderCustomAddressFinderDropdown()}
          <FormInputAddressFinderManualSwitch
            field={PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_FIELD}
            information={information}
            setInformation={setInformation}
            setValidation={setValidation}
          />
          <SizeBox height={16} />
          {renderFormEnterAddressManual()}
          <SizeBox height={isDesktop ? 0 : 240} />
          {renderBottomFixed()}
        </FormPIIProfileResidentialAddressStyled>
      );
    }
  )
);

const FormPIIProfileResidentialAddressStyled = styled.div``;

const FormEnterAddressManualStyled = styled.div``;
const EnterAddressManualRow = styled.div`
  display: flex;
  gap: 12px;
`;

const BottomFixedStyled = styled.div`
  ${displayFlexRowCenterSpaceBetweenMixin};
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  padding: 12px 16px;
  border-top: 1px solid var(--ds-c-grey-disabled);
  background-color: #fff;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    position: unset;
    border-top: unset;
    padding: 0;
  }
`;

export default FormPIIProfileResidentialAddress;
